import type { Row } from '@tanstack/react-table'
import * as React from 'react'

import { Checkbox } from '../checkbox/Checkbox'
import { useDataTable } from './DataTableContext'

export const DataTableRowSelectionCheckbox = ({
  row,
  checked,
  onCheckedChange,
  label = `Row ${row.id} selection`
}: {
  row: Row<Record<string, unknown>>
  checked: boolean | 'indeterminate'
  onCheckedChange: (value: boolean) => void
  label?: string
}): React.ReactElement<unknown> => {
  const { tableId } = useDataTable()

  return (
    <>
      <label htmlFor={`${tableId}_row_${row.id}_selection`} className="sr-only">
        {label}
      </label>
      <Checkbox
        size="lg"
        style={{ '--depth': row.depth }}
        checked={checked}
        onCheckedChange={onCheckedChange}
        name={`${tableId}_row_${row.id}_selection`}
        disabled={!row.getCanSelect()}
        className="mr-3 ml-[calc((var(--depth,0)*2)*4px)]"
      />
    </>
  )
}
